import { gql } from "@apollo/client";

const ACTION_MUTATION = gql`
  mutation save_changelist($changelist_id: String, $action: String) {
    save_changelist(changelist_id: $changelist_id, action: $action) {
      ... on SaveChangelistOk {
        changelist {
          id
          description
          created_on
          updated_on
          status
        }
      }
    }
  }
`;

const BRANCH_CHANGELIST_MUTATION = gql`
  mutation branch_changelist($description: String!, $changelist_id: String) {
    branch_changelist(description: $description, changelist_id: $changelist_id) {
      changelist {
        id
        description
        created_on
        updated_on
        status
      }
    }
  }
`;

const RENAME_CHANGELIST_DESCRIPTION_MUTATION = gql`
  mutation rename_changelist($changelist_id: String, $changelist: SaveChangelistInput) {
    save_changelist(changelist_id: $changelist_id, changelist: $changelist) {
      ... on SaveChangelistOk {
        changelist {
          description
        }
      }
    }
  }
`;
const UPDATE_CHANGELIST_MUTATION = gql`
  mutation update_changelist(
    $changelist_id: String
    $changelist: SaveChangelistInput
    $action: String
    $fetch_new_downloads: Boolean
    $test_exports: [String]
    $force_publish: Boolean
  ) {
    save_changelist(
      changelist_id: $changelist_id
      changelist: $changelist
      action: $action
      fetch_new_downloads: $fetch_new_downloads
      test_exports: $test_exports
      force_publish: $force_publish
    ) {
      ... on SaveChangelistOk {
        changelist {
          description
          files {
            path
          }
          compilation_result {
            declarations {
              name
              connector_type
              path
              line
              column
              declaration_type
              test
              key_name
            }
            messages {
              type
              path
              line
              column
              message
              startLine
              startColumn
              endLine
              endColumn
            }
          }
        }
        action
      }
      ... on NeedsMergeError {
        message
      }
    }
  }
`;

export {
  ACTION_MUTATION,
  BRANCH_CHANGELIST_MUTATION,
  RENAME_CHANGELIST_DESCRIPTION_MUTATION,
  UPDATE_CHANGELIST_MUTATION,
};
